import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { RootState } from '../../../state/state';
import { removeReservationFromSearchHistory } from '../../../services/reservation-search-history-service/state/reservation-search-history.actions';
import { Subject, takeUntil } from 'rxjs';
import { ReservationSearchHistorySelectors } from '../../../services/reservation-search-history-service/state/reservation-search-history.selectors';
import { Router, RouterModule } from '@angular/router';
import { RefreshService } from '../../../services/refresh-service/refresh.service';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../../../directives/directives.module';

@Component({
  selector: 'app-recent-confirmation-code-tile',
  templateUrl: './recent-confirmation-code-tile.component.html',
  styleUrls: ['./recent-confirmation-code-tile.component.scss'],
  imports: [CommonModule, RouterModule, DirectivesModule],
})
export class RecentConfirmationCodeTileComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly router = inject(Router);

  @Input() id: string;
  @Input() confirmationCode: string;
  @Input() isActive: boolean;
  @Input() passengerNames: string;
  @Input() tileClasses: string;
  confirmationCodes: string[] | number[];
  onlySingleConfirmationCode = false;
  isHovered = false;
  private readonly onDestroy$ = new Subject<void>();

  private readonly refreshService = inject(RefreshService);

  ngOnInit(): void {
    this.store
      .pipe(select(ReservationSearchHistorySelectors.getConfirmationCodes), takeUntil(this.onDestroy$))
      .subscribe((confirmationCodes) => {
        this.confirmationCodes = confirmationCodes;
        this.onlySingleConfirmationCode = confirmationCodes?.length === 1;
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  onHover() {
    this.isHovered = true;
  }

  onLeave() {
    this.isHovered = false;
  }

  removeConfirmationCode() {
    // Confirmation codes is in a reversed order.
    // If you close the first confirmation code and it is active,
    // you should be redirected to the last confirmation code you looked up.
    if (this.confirmationCode === this.confirmationCodes[this.confirmationCodes.length - 1] && this.isActive) {
      this.router.navigate(['reservation', this.confirmationCodes[this.confirmationCodes.length - 2]]);
    }
    // If you close the last/middle confirmation code and it is active,
    // you should be redirected to the last confirmation code you looked up.
    else if (this.isActive) {
      this.router.navigate(['reservation', this.confirmationCodes[this.confirmationCodes.length - 1]]);
    }
    this.store.dispatch(removeReservationFromSearchHistory(this.confirmationCode));
  }

  navigateToReservation(confirmationCode: string) {
    this.refreshService.refreshReservation(confirmationCode);
  }
}
